export default __webpack_public_path__ + "static/B0273-5f8ea280037f81d3de1e1776986bce47.png";